import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux'
import {useNavigate, useParams} from "react-router-dom";
import logo from '../../assets/site-logo.png';
import * as Routes from "../../utils/routes";
import {getAuth, createUserWithEmailAndPassword} from "firebase/auth";
import app from '../../utils/firebase';
import * as userActions from '../../redux/User/actions';
import LoadingPanel from "../../components/LoadingPanel";
import signupButton from '../../assets/signup-button.png';
import ball1 from '../../assets/home/ball1.png';
import ball2 from '../../assets/home/ball2.png';
import ball3 from '../../assets/home/ball3.png';
import FloatingImage from "../../components/FloatingImage";
import {isValidPassword} from "../../utils/general.js";
import './SignUpPage.scss';

const auth = getAuth(app);

const SignupPage = props => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	const [pass, setPass] = useState("");
	const [pass2, setPass2] = useState("");
	const [user, setUser] = useState(null);
	const navigate = useNavigate();
	const params = useParams();

	// const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			const inviteResponse = (userData) => {
				if(userData == null) {
					navigate(Routes.ERROR);
				}
				else {
					setUser(userData);
					setLoading(false);
				}
			};

			await dispatch(userActions.checkInvite(params.hash, inviteResponse));
		};
		load();
	}, [dispatch, navigate, params.hash]);

	const doSignup = async () => {
		setError("");

		if(pass.length < 1 || pass2.length < 1) {
			setError("Please fill both passwords.");
		}
		else if(!isValidPassword(pass)) {
			setError("Enter passwords of 8 chars containing 1 upper, 1 lower and 1 digit.");
		}
		else if(pass !== pass2) {
			setError("Passwords do not match.");
		}
		else {
			createUserWithEmailAndPassword(auth, user.email, pass)
				.then(async (userCredential) => {
					const newUser = userCredential.user;
					console.log("User created:", newUser);
					await dispatch(userActions.registerUser(newUser.email, newUser.uid, () => {
						navigate(Routes.SIGN_IN);
					}));
				})
				.catch((error) => {
					const errorCode = error.code;
					if(errorCode === "auth/email-already-in-use") {
						setError("User already registered.");
					}
					else {
						console.log(errorCode);
					}
				});
		}
	};

	if(loading) {
		return <div/>
	}

	return (
		<div className="signup-container">

			{ loading && <LoadingPanel /> }

			<img src={logo} alt="" className="signup-logo" />

			<div style={{position: 'absolute', bottom: '100px', left: '20vw'}}>
				<FloatingImage src={ball1} uid="ball1" animationDuration={2500} fromValue={0} toValue={-150} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', left: '30vw'}}>
				<FloatingImage src={ball2} uid="ball2" animationDuration={1500} fromValue={-40} toValue={-120} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', right: '20vw'}}>
				<FloatingImage src={ball3} uid="ball3" animationDuration={5000} fromValue={0} toValue={-230} />
			</div>

			<form>
				<div className="signup-box-wrapper">
					<div className="signup-box">
						<div/>
						<div style={{fontSize: '19px', color: '#142A31', fontWeight: 700}}>{user.display_name ? `Hi ${user.display_name.split(" ")[0]}!` : 'Hi!'}</div>

						<div className="signup-description">
							You have been invited to join the CONNACT platform. Please use the form below to create your new password.
						</div>

						<br/>

						<input type="text" autoComplete="username" defaultValue={user.email} className="signup-input" readOnly disabled style={{userSelect: 'none', backgroundColor: '#e3e3e3'}} />
						<input type="password" autoComplete="new-password" value={pass} onChange={e => setPass(e.target.value)} className="signup-input" placeholder="Password" />
						<input type="password" autoComplete="new-password" value={pass2} onChange={e => setPass2(e.target.value)} className="signup-input" placeholder="Verify Password" />

						<div className="signup-error">{error}&nbsp;</div>

						<img src={signupButton} alt="" className="signup-button" onClick={doSignup} />

						<br/>
					</div>
				</div>
			</form>

			<div className="email-row">Email us at <a href="mailto:support@connact.cloud"><b>support@connact.cloud</b></a> for any issues</div>
		</div>
	)
};

export default SignupPage;
